import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var _BaseNotFound;
function _callSuper(_this, derived, args) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      return !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (e) {
      return false;
    }
  }
  derived = _getPrototypeOf(derived);
  return _possibleConstructorReturn(_this, isNativeReflectConstruct() ? Reflect.construct(derived, args || [], _getPrototypeOf(_this).constructor) : derived.apply(_this, args));
}
/** @jsx jsx */
import { Component } from 'react';
import { Heading } from '@instructure/ui-heading';
import { jsx } from '@instructure/emotion';
import PropTypes from 'prop-types';
import { Card, Page } from '@instructure/quiz-core';
import t from '@instructure/quiz-i18n/format-message';
import generateStyle from './styles';
import generateComponentTheme from './theme';
import { withStyleOverrides } from '@instructure/quiz-common';
export var BaseNotFound = /*#__PURE__*/function (_Component) {
  function BaseNotFound() {
    _classCallCheck(this, BaseNotFound);
    return _callSuper(this, BaseNotFound, arguments);
  }
  _inherits(BaseNotFound, _Component);
  return _createClass(BaseNotFound, [{
    key: "render",
    value: function render() {
      return jsx(Page, null, jsx(Card, {
        wrapped: true,
        css: this.props.styles.wrapper
      }, jsx("div", {
        css: this.props.styles.hero
      }, '404' /* eslint-disable-line react/jsx-no-literals */), jsx("div", {
        css: this.props.styles.textWrapper
      }, jsx("div", {
        css: this.props.styles.title
      }, jsx(Heading, {
        level: "h2",
        as: "h1"
      }, t('Page Not Found'))), jsx("div", {
        css: this.props.styles.subtitle
      }, t('We cannot find the page you requested. Sorry...')))));
    }
  }]);
}(Component);
_BaseNotFound = BaseNotFound;
_defineProperty(BaseNotFound, "displayName", 'NotFound');
_defineProperty(BaseNotFound, "componentId", "Quizzes".concat(_BaseNotFound.displayName));
_defineProperty(BaseNotFound, "propTypes", {
  styles: PropTypes.object
});
export var NotFound = withStyleOverrides(generateStyle, generateComponentTheme)(BaseNotFound);
export default NotFound;